import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

export default function Loading() {
    return (
        <Grid container spacing={1.5} mt={2}>
            <Grid item xs={8} display="flex" alignItems="center" justifyContent="center">
                <Box display="flex" flexDirection="column" alignItems="center" width="100%" gap={1}>
                    {[...Array(5)].map((row, index) => (
                        <Skeleton
                            key={index}
                            height={50}
                            animation="wave"
                            variant="rounded"
                            sx={{ width: "100%" }}
                        />
                    ))}
                </Box>
            </Grid>
        </Grid>
    );
};